/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import ActionTypes from '../actions/actionTypes'

const initialState = {}

export default (state = initialState, action) => {
  if (action.type === ActionTypes.ENROLLMENT_SUMMARY) {
    return {
      ...state,
      [action.data.id]: action.data.summary,
    }
  } else {
    return state
  }
}
